export class ImportZipRequest {
   base64content: string;
   fileList: Array<string> = [];

   constructor(b64Content: string, fileList: Array<string>) {
      this.base64content = b64Content;
      this.fileList = fileList;
   }
}